module.exports = __webpack_public_path__ + "img/sarpaodisha_1.23807a05.png";